import { FormattedMessage } from 'react-intl'

import { Form } from '@subaio/components/src/HookForm'
import { mapLocaleOptions } from '@subaio/webapp'

import { ButtonGroup, ButtonSelect, ButtonSolidSubmit } from 'components/Buttons'
import { Input } from 'components/FormFields'
import { IconWarning } from 'components/Icons'
import { InfoBox } from 'components/InfoBox'
import { Card, ConstrainedContent } from 'components/Layout'

type Props = {
	locale: string
	localeOptions: Array<string>
	hasInvalidLogin: boolean
	hasUnknownError: boolean

	onSubmit: (code: string) => Awaitable<void>
	setLocale: (locale: string) => void
}

export const AuthenticationForm = ({
	onSubmit,
	hasInvalidLogin,
	hasUnknownError,
	locale,
	localeOptions,
	setLocale,
}: Props) => (
	<Card title={<FormattedMessage id='authentication.subtitle' defaultMessage='Enter your password' />}>
		<Form<{ code: string }>
			render={() => (
				<>
					<ConstrainedContent>
						<Input
							label={<FormattedMessage id='authentication.labelCode' defaultMessage='Enter code' />}
							name='code'
							type='password'
							isRequired
						/>
						<ButtonSelect
							label={<FormattedMessage id='authentication.labelLanguage' defaultMessage='Select language' />}
							options={mapLocaleOptions(localeOptions, { shortName: true })}
							selectedValue={locale}
							typeOfOptions='locale'
							onSelect={(value) => setLocale(value)}
						/>
						{hasInvalidLogin && (
							<InfoBox type='danger'>
								<div>
									<IconWarning />
									<h2>
										<FormattedMessage
											id='authentication.invalidTitle'
											defaultMessage='The link and/or code is invalid'
										/>
									</h2>
								</div>
								<div>
									<FormattedMessage
										id='authentication.invalid'
										defaultMessage='If the issue persists, reach out to your advisor.'
									/>
								</div>
							</InfoBox>
						)}
						{hasUnknownError && (
							<InfoBox type='danger'>
								<div>
									<IconWarning />
									<h2>
										<FormattedMessage
											id='authentication.unknownErrorTitle'
											defaultMessage='An unknown error occurred'
										/>
									</h2>
								</div>
								<div>
									<FormattedMessage
										id='authentication.invalid'
										defaultMessage='If the issue persists, reach out to your advisor.'
									/>
								</div>
							</InfoBox>
						)}
						<p>
							<FormattedMessage
								id='authentication.description'
								defaultMessage='Thank you for helping us understand your finances.'
							/>
						</p>
						<p>
							<FormattedMessage
								id='authentication.description2'
								defaultMessage='It typically takes 5-10 minutes to complete the process.'
							/>
						</p>
					</ConstrainedContent>
					<ButtonGroup>
						<ButtonSolidSubmit label={<FormattedMessage id='authentication.buttonSubmit' defaultMessage='Start' />} />
					</ButtonGroup>
				</>
			)}
			onSubmit={(fields) => onSubmit(fields.code)}
		/>
	</Card>
)
